/**
 * 页面文案词典 —— English
 * Batch 4: site-wide wrap-up (MyWebsite / WidgetPanel / Navigation / Permission / SiteConfig / Engine ...)
 */
export default {
  '操作失败': 'Operation failed',
  '成功': 'Success',
  '删除失败': 'Deletion failed',
  '网络错误': 'Network error',
  '保存失败': 'Save failed',
  '其他': 'Other',
  '制造业': 'Manufacturing',
  '医疗健康': 'Healthcare',
  '合资': 'Joint Venture',
  '启用': 'Enable',
  '国企': 'State-owned',
  '外企': 'Foreign-funded',
  '失败': 'Failed',
  '房地产': 'Real Estate',
  '教育培训': 'Education & Training',
  '正常': 'Normal',
  '民企': 'Private',
  '物流运输': 'Logistics & Transport',
  '电子商务': 'E-commerce',
  '软件开发': 'Software',
  '金融业': 'Finance',
  '上传失败': 'Upload failed',
  '中文名称': 'Chinese Name',
  '分站状态': 'Sub-site Status',
  '守卫名称': 'Guard Name',
  '已开启': 'Enabled',
  '开启分站': 'Enable Sub-site',
  '普通': 'Regular',
  '未开启': 'Disabled',
  '未知': 'Unknown',
  '添加绑定': 'Add Binding',
  '禁用': 'Disable',
  '绑定失败': 'Binding failed',
  '绑定成功': 'Bound successfully',
  '编码': 'Code',
  '翻译失败': 'Translation failed',
  '行业': 'Industry',
  '行政代码': 'Admin Code',
  '解绑成功': 'Unbound successfully',
  ' 条结构警告，请人工复核译文': ' structure warnings, please review the translation manually',
  ' 段...': ' segments...',
  '// 请先选择企业': '// Please select a company first',
  '上传成功': 'Uploaded successfully',
  '主题描述': 'Topic Description',
  '主题标题': 'Topic Title',
  '产品中心': 'Products',
  '企庭中国民营经济网': 'Qiting China Private Economy Network',
  '分类名称': 'Category Name',
  '分配权限': 'Assign Permissions',
  '创建失败': 'Creation failed',
  '刷新预览': 'Refresh Preview',
  '发送失败': 'Failed to send',
  '在新窗口打开': 'Open in New Window',
  '复制失败，请手动选中复制': 'Copy failed, please select and copy manually',
  '媒体矩阵格子': 'Media Matrix Cell',
  '已发布': 'Published',
  '已复制到剪贴板': 'Copied to clipboard',
  '已拒绝': 'Rejected',
  '已认证': 'Verified',
  '所属城市': 'City',
  '所属导航': 'Navigation',
  '所属省份': 'Province',
  '打开首页': 'Open Homepage',
  '批量导入链接': 'Bulk Import Links',
  '抖音': 'Douyin',
  '排序 / 操作': 'Sort / Actions',
  '新增权限': 'New Permission',
  '新建': 'New',
  '新建企业账号': 'New Company Account',
  '新建分类': 'New Category',
  '新建违禁词': 'New Banned Word',
  '日期筛选：': 'Date filter:',
  '更新失败': 'Update failed',
  '未使用': 'Unused',
  '标题 *': 'Title *',
  '标题必填': 'Title is required',
  '正在翻译正文 第 ': 'Translating body, segment ',
  '添加格子': 'Add Cell',
  '登录失败': 'Login failed',
  '确认导入': 'Confirm Import',
  '第 ': 'Segment ',
  '编辑成功': 'Edited successfully',
  '编辑文章': 'Edit Article',
  '翻译完成': 'Translation complete',
  '翻译标题...': 'Translating title...',
  '草稿': 'Draft',
  '获取权限列表失败': 'Failed to load permission list',
  '角色名称': 'Role Name',
  '解析链接': 'Parse Links',
  '该平台没有公开主页链接，建议改上传二维码': 'This platform has no public profile link; uploading a QR code is recommended',
  '请先选择企业': 'Please select a company first',
  '请填写所有必填字段': 'Please fill in all required fields',
  '请检查表单：格子标题不能为空': 'Please check the form: cell title cannot be empty',
  '请输入标题': 'Please enter a title',
  '请输入正确的URL格式': 'Please enter a valid URL',
  '近30天': 'Last 30 days',
  '返回列表': 'Back to List',
  '返回首页': 'Back to Home',
  '还有 ': ' remaining',
  '违禁词': 'Banned Words',
  '顶级权限': 'Top-level Permission',
  '首页轮播图': 'Homepage Carousel',
  ' 段 <': ' segments <',
  ' 段翻译失败，已保留原文：': ' segment(s) failed to translate, original kept:',
  ')，请人工复核': '), please review manually',
  '/译文': '/translation',
  '2 列 grid2': '2 columns',
  '3 列 grid3': '3 columns',
  '4 列 grid4': '4 columns',
  '> 标签数不一致(原文': '> tag count mismatch (original',
  'AI 写作中...': 'AI writing...',
  'AI 正在翻译...': 'AI translating...',
  'AI 正在翻译中...': 'AI translating...',
  'AI写作': 'AI Writing',
  'AI文章': 'AI Articles',
  'AI花费': 'AI Cost',
  'Token消耗': 'Token Usage',
  'www.chpen.com 首页导航栏实时预览': 'www.chpen.com live preview of the homepage navigation bar',
  '⏳ AI 正在写作中...': '⏳ AI is writing...',
  '一键填充九宫格': 'Auto-fill 3x3 Grid',
  '上传封面图': 'Upload Cover Image',
  '上海企庭财务管理有限公司总经理，注册公司/代理记账/税务筹划/外贸结汇': 'GM of Shanghai Qiting Financial Management Co., Ltd. — company registration / bookkeeping / tax planning / forex settlement',
  '不允许上传 SVG 图片': 'SVG images are not allowed',
  '丢弃': 'Discard',
  '中文正文': 'Chinese Body',
  '主体': 'Entity',
  '九宫格条目（拖动顺序请用上移/下移）': '3x3 Grid Items (use Move Up / Move Down to reorder)',
  '二维码设置': 'QR Code Settings',
  '产品介绍': 'Product Introduction',
  '企业': 'Company',
  '企业入驻 · 新闻管理 · 资金清算': 'Company Onboarding · News Management · Fund Settlement',
  '企业全球 ID': 'Company Global ID',
  '企业列表加载中或为空': 'Company list is loading or empty',
  '企业列表加载失败，请刷新页面重试': 'Failed to load company list, please refresh the page',
  '企业宣传': 'Company Promotion',
  '企业宣传片': 'Company Promo Video',
  '企业把多个平台链接一次性贴进来，系统自动识别平台并生成格子': 'Paste multiple platform links at once; the system detects each platform and generates cells',
  '企业类型': 'Company Type',
  '企业：': 'Company:',
  '企庭中国民营经济网创始人，深度 AI 实践者': 'Founder of Qiting China Private Economy Network, deep AI practitioner',
  '企庭创始人 & CEO': 'Qiting Founder & CEO',
  '使用时间': 'Usage Time',
  '保存修改': 'Save Changes',
  '保存后公开页面会即刻更新；上下线开关请联系平台管理员': 'The public page updates immediately after saving; contact the platform admin to toggle online/offline',
  '保存失败，请稍后重试': 'Save failed, please retry later',
  '保存失败：': 'Save failed:',
  '保存并授权开通': 'Save & Authorize',
  '信用代码': 'Credit Code',
  '停止': 'Stop',
  '充值日期': 'Recharge Date',
  '充值金额': 'Recharge Amount',
  '全球 ID': 'Global ID',
  '全部文章': 'All Articles',
  '公司名称': 'Company Name',
  '关于我们': 'About Us',
  '关联地区': 'Related Region',
  '关联权限数': 'Linked Permissions',
  '关联用户数': 'Linked Users',
  '关键词(逗号分隔)': 'Keywords (comma separated)',
  '关闭后公开页显示『已暂停展示』，配置保留': 'When off, the public page shows "Display Paused"; the configuration is kept',
  '其子菜单也会被删除。': 'Its submenus will be deleted as well.',
  '内容预览': 'Content Preview',
  '写文章': 'Write Article',
  '准备翻译...': 'Preparing translation...',
  '创始人兼总经理 | 会计师': 'Founder & GM | Accountant',
  '创建': 'Create',
  '创建成功，首页导航已同步': 'Created; homepage navigation synced',
  '删除成功，首页导航已同步': 'Deleted; homepage navigation synced',
  '删除配置': 'Delete Config',
  '加载企业信息失败': 'Failed to load company info',
  '加载失败，请稍后重试': 'Failed to load, please retry later',
  '加载失败：': 'Failed to load:',
  '加载导航数据失败': 'Failed to load navigation data',
  '加载导航选项失败': 'Failed to load navigation options',
  '加载网站配置失败': 'Failed to load site config',
  '动作': 'Action',
  '区县名称': 'District / County Name',
  '即将上线': 'Coming soon',
  '友情链接设置': 'Friend Links Settings',
  '发布成功': 'Published successfully',
  '发布状态': 'Publish Status',
  '发送中': 'Sending',
  '发送方式': 'Delivery Method',
  '发送时间': 'Sent At',
  '发送验证码': 'Send Code',
  '受控动作总闸（白名单自愈动作）': 'Controlled Actions Master Switch (whitelisted self-healing actions)',
  '变更前': 'Before',
  '变更后': 'After',
  '可优化': 'Optimizable',
  '可用': 'Available',
  '启用中': 'Enabling',
  '启用但未展示': 'Enabled but not displayed',
  '吴琼': 'Wu Qiong',
  '告警收件邮箱': 'Alert Recipient Email',
  '告警通知总闸（邮件）': 'Alert Notification Master Switch (email)',
  '固定高度版': 'Fixed Height Version',
  '图片上传失败': 'Image upload failed',
  '图片上传失败: ': 'Image upload failed: ',
  '图片上传成功': 'Image uploaded successfully',
  '图片大小不能超过20MB': 'Image size must not exceed 20MB',
  '城市名称': 'City Name',
  '基本信息': 'Basic Info',
  '填充到：': 'Fill into:',
  '子菜单': 'Submenu',
  '子菜单分布：': 'Submenu distribution:',
  '学习层总闸（0=只算不写库）': 'Learning Layer Master Switch (0 = compute only, no DB write)',
  '官网首页': 'Official Website Homepage',
  '实收充值（已收到款）': 'Actual Recharge (payment received)',
  '审核备注（可选）': 'Review Note (optional)',
  '密码登录': 'Password Login',
  '导航菜单编辑（直接控制首页导航栏）': 'Navigation Menu Editing (directly controls the homepage nav bar)',
  '已使用': 'Used',
  '已保存（即时生效）': 'Saved (effective immediately)',
  '已停止': 'Stopped',
  '已删除该企业的挂件配置': 'Widget config for this company has been deleted',
  '已发布!': 'Published!',
  '已恢复本地草稿': 'Local draft restored',
  '已授权 · 公开页可见': 'Authorized · visible on the public page',
  '已用抖音昵称 / 头像填充抖音格子，记得点保存': 'Douyin cell filled with nickname / avatar, remember to save',
  '已解绑': 'Unbound',
  '已过期': 'Expired',
  '已退出登录': 'Logged out',
  '已通过': 'Approved',
  '平台授信': 'Platform Credit',
  '年份': 'Year',
  '开启后引擎将自动微调自身配置（有护栏+可回滚），确认？': 'Once enabled, the engine will auto-tune its own config (with guardrails + rollback). Confirm?',
  '当前余额': 'Current Balance',
  '当前账号权限已变更，正在刷新页面...': 'Your permissions have changed, refreshing the page...',
  '当前钱包余额：': 'Current wallet balance:',
  '微信联系': 'WeChat',
  '快手号': 'Kuaishou ID',
  '总站（显示在首页导航栏）': 'Main Site (shown in the homepage nav bar)',
  '总花费': 'Total Cost',
  '恢复草稿': 'Restore Draft',
  '成本(元)': 'Cost (¥)',
  '所属企业': 'Company',
  '所属行业': 'Industry',
  '所选条目没有可导入的图片或信息，请改选其他条目': 'The selected items have no importable image or info; please pick others',
  '所选条目都没有图片，轮播图需要图片，请改选其他条目': 'None of the selected items have images; the carousel requires images. Please pick others',
  '手动写作': 'Manual Writing',
  '手动重挖': 'Manual Re-mining',
  '批次翻译失败': 'Batch translation failed',
  '批次翻译结果为空': 'Batch translation returned empty',
  '把抖音 / 快手 / 小红书等平台链接一次性贴进来，系统自动识别平台并生成格子': 'Paste Douyin / Kuaishou / Xiaohongshu links at once; the system detects platforms and generates cells',
  '把这段代码粘到你现有网站的页面里，展示的是紧凑九宫格形态（脚本用于 iframe 高度自适应）。': 'Paste this code into a page of your existing website; it renders a compact 3x3 grid (the script auto-adjusts iframe height).',
  '抖音号': 'Douyin ID',
  '抖音用户': 'Douyin User',
  '抖音绑定失败，请重试': 'Douyin binding failed, please retry',
  '抖音绑定成功': 'Douyin bound successfully',
  '挂件配置': 'Widget Config',
  '挂件配置已保存': 'Widget config saved',
  '授信': 'Credit',
  '排序(数字越小越靠前)': 'Sort (smaller number = higher priority)',
  '排序失败': 'Sorting failed',
  '排序已更新': 'Order updated',
  '探针': 'Probe',
  '提现审核_': 'Withdrawal Review_',
  '支持直接粘贴抖音/小红书的分享口令（整段复制的文案），系统会自动识别里面的链接。\n例：\n【抖音】复制此条信息，打开抖音搜索我 https://v.douyin.com/xxxxx/\n12 小红书发布了一篇笔记，快来看吧 https://www.xiaohongshu.com/discovery/item/xxxx\nhttps://www.kuaishou.com/profile/xxxx\nhttps://www.example.com': 'You can paste Douyin / Xiaohongshu share text (the whole copied message) directly; the system will detect the links inside.\nExample:\n[Douyin] Copy this message, open Douyin and search for me https://v.douyin.com/xxxxx/\n12 Xiaohongshu posted a note, come and see https://www.xiaohongshu.com/discovery/item/xxxx\nhttps://www.kuaishou.com/profile/xxxx\nhttps://www.example.com',
  '支持直接粘贴抖音/小红书的分享口令（整段复制的文案），系统会自动识别里面的链接，并按平台归类。': 'You can paste Douyin / Xiaohongshu share text (the whole copied message); the system detects the links and groups them by platform.',
  '故障持续重复提醒间隔（轮）': 'Repeat Alert Interval for Persistent Failures (rounds)',
  '敬请期待': 'Coming soon',
  '数字人助理': 'Digital Human Assistant',
  '文章标题': 'Article Title',
  '新增企业': 'New Company',
  '新增区县': 'New District / County',
  '新增城市': 'New City',
  '新增导航': 'New Navigation',
  '新增省份': 'New Province',
  '新增管理员': 'New Admin',
  '新增顶级导航': 'New Top-level Nav',
  '新建SEO主题': 'New SEO Topic',
  '新建主题': 'New Topic',
  '新窗口看全站': 'Open Full Site in New Window',
  '新闻资讯': 'News',
  '无': 'None',
  '日期筛选：近30天': 'Date filter: last 30 days',
  '是': 'Yes',
  '是否菜单': 'Is Menu',
  '普通用户': 'Regular User',
  '暂无权限数据': 'No permission data',
  '暂未获取到抖音授权配置，请联系平台管理员开通': 'Douyin authorization config unavailable; contact the platform admin to enable it',
  '更多数字人助理正在接入中，敬请期待': 'More digital human assistants are being onboarded, stay tuned',
  '更新': 'Update',
  '更新成功': 'Updated successfully',
  '更新成功，首页导航已同步': 'Updated; homepage navigation synced',
  '最后活动': 'Last Active',
  '最多 100 字': 'Max 100 characters',
  '最多 200 字': 'Max 200 characters',
  '最多 24 个格子': 'Max 24 cells',
  '最新': 'Latest',
  '月份': 'Month',
  '未抓到公开信息，请手动补充标题 / 图片': 'No public info captured; please fill in the title / image manually',
  '未授权 · 公开页不展示': 'Unauthorized · hidden on the public page',
  '未知错误': 'Unknown error',
  '未解析出任何可导入的条目': 'No importable entries were parsed',
  '权限分配失败': 'Permission assignment failed',
  '权限名称': 'Permission Name',
  '标记': 'Flag',
  '模块': 'Module',
  '模板类型': 'Template Type',
  '正在上传图片...': 'Uploading image...',
  '每行粘贴一个链接，系统自动识别平台并生成格子。支持抖音 / 快手 / 小红书 / 官网等。': 'Paste one link per line; the system detects the platform and generates cells. Supports Douyin / Kuaishou / Xiaohongshu / official site, etc.',
  '没有匹配的企业': 'No matching company',
  '法定代表人': 'Legal Representative',
  '注册账号总数': 'Total Registered Accounts',
  '注册资本': 'Registered Capital',
  '浅色 light': 'Light',
  '浏览量': 'Views',
  '深度分析': 'Deep Analysis',
  '深色 dark': 'Dark',
  '添加产品': 'Add Product',
  '添加友情链接': 'Add Friend Link',
  '添加成功': 'Added successfully',
  '添加轮播图': 'Add Carousel Image',
  '点击开始对话': 'Click to start chatting',
  '热门': 'Trending',
  '生成中...': 'Generating...',
  '生成失败': 'Generation failed',
  '生成完成': 'Generation complete',
  '生成耗时(秒)': 'Generation Time (s)',
  '用户ID': 'User ID',
  '用户类型': 'User Type',
  '用过聊天': 'Used Chat',
  '电话咨询': 'Phone Consultation',
  '登录失败，请检查返回': 'Login failed, please check the response',
  '登录已过期，请重新登录': 'Session expired, please log in again',
  '省份名称': 'Province Name',
  '短信价格(元)': 'SMS Price (¥)',
  '短信登录': 'SMS Login',
  '短信花费': 'SMS Cost',
  '确认提交?': 'Confirm submit?',
  '禁用后不显示在首页': 'Hidden from the homepage when disabled',
  '移除': 'Remove',
  '简称': 'Short Name',
  '管理员': 'Admin',
  '管理端 vs 首页同步状态': 'Admin Panel vs Homepage Sync Status',
  '管理端与首页数据完全一致': 'Admin panel and homepage data are fully consistent',
  '管理端有但首页未展示': 'Present in admin panel but not shown on homepage',
  '级别': 'Level',
  '纯授信（先给额度）': 'Pure Credit (limit granted first)',
  '绑定后自动同步抖音昵称与头像，无需手动填写。': 'After binding, the Douyin nickname and avatar sync automatically — no manual input needed.',
  '结论': 'Conclusion',
  '缓存清理触发线（MB）': 'Cache Cleanup Threshold (MB)',
  '编辑SEO主题': 'Edit SEO Topic',
  '编辑企业账号': 'Edit Company Account',
  '编辑企业：': 'Edit company:',
  '编辑分类': 'Edit Category',
  '编辑区县': 'Edit District / County',
  '编辑城市': 'Edit City',
  '编辑权限': 'Edit Permission',
  '编辑省份': 'Edit Province',
  '编辑违禁词': 'Edit Banned Word',
  '缺少企业ID': 'Missing company ID',
  '网站主题色': 'Site Theme Color',
  '置信度': 'Confidence',
  '翻译中...': 'Translating...',
  '翻译结果为空': 'Translation result is empty',
  '翻译结果为空，请手动填写': 'Translation result is empty, please fill it in manually',
  '翻译请求失败: HTTP ': 'Translation request failed: HTTP ',
  '耗时(ms)': 'Time (ms)',
  '联系我们': 'Contact Us',
  '联系电话': 'Phone',
  '自动保存已开启（本地草稿）': 'Auto-save enabled (local draft)',
  '自动翻译为英文': 'Auto-translate to English',
  '自检周期（秒，下限30）': 'Self-check Interval (seconds, min 30)',
  '自适应档位': 'Adaptive Tier',
  '自适应高度版（推荐）': 'Auto Height Version (recommended)',
  '英文标题': 'English Title',
  '英文标题不能超过255字符（数据库上限）': 'English title must not exceed 255 characters (DB limit)',
  '草稿已保存': 'Draft saved',
  '草稿箱': 'Drafts',
  '获取角色列表失败': 'Failed to load role list',
  '行业报告': 'Industry Report',
  '规则': 'Rule',
  '规则重挖完成': 'Rule re-mining complete',
  '解析失败，请稍后重试': 'Parsing failed, please retry later',
  '解绑失败，请稍后重试': 'Unbinding failed, please retry later',
  '触发': 'Trigger',
  '证据': 'Evidence',
  '该平台未开放对外接口，请在下方媒体矩阵中手动填写并上传二维码/封面': 'This platform has no public API; please fill in the media matrix below and upload a QR code / cover',
  '请上传网站Logo': 'Please upload the site logo',
  '请先输入中文标题和正文内容': 'Please enter the Chinese title and body first',
  '请求失败': 'Request failed',
  '请求方法': 'Request Method',
  '请确认信息已正确填写后再提交。': 'Please make sure the information is correct before submitting.',
  '请联系平台管理员开通': 'Contact the platform admin to enable it',
  '请联系平台管理员开通抖音授权': 'Contact the platform admin to enable Douyin authorization',
  '请输入URI': 'Please enter a URI',
  '请输入企业名称': 'Please enter the company name',
  '请输入内容': 'Please enter content',
  '请输入写作要求': 'Please enter your writing requirements',
  '请输入分类名称': 'Please enter a category name',
  '请输入导航名称': 'Please enter a navigation name',
  '请输入文章正文内容...': 'Please enter the article body...',
  '请输入权限名称': 'Please enter a permission name',
  '请输入模块': 'Please enter a module',
  '请输入正确的手机号': 'Please enter a valid phone number',
  '请输入正确的邮箱格式': 'Please enter a valid email address',
  '请输入正确的链接地址格式': 'Please enter a valid link URL',
  '请输入版权名称': 'Please enter the copyright name',
  '请输入版权链接': 'Please enter the copyright link',
  '请输入简称': 'Please enter a short name',
  '请输入管理后台地址': 'Please enter the admin panel URL',
  '请输入网站描述': 'Please enter the site description',
  '请输入网站标题': 'Please enter the site title',
  '请输入联系地址': 'Please enter the contact address',
  '请输入联系电话': 'Please enter the phone number',
  '请输入联系邮箱': 'Please enter the contact email',
  '请输入英文名称': 'Please enter the English name',
  '请输入英文版权名称': 'Please enter the English copyright name',
  '请输入英文网站描述': 'Please enter the English site description',
  '请输入英文联系地址': 'Please enter the English contact address',
  '请输入角色名称': 'Please enter a role name',
  '请输入链接名称': 'Please enter a link name',
  '请输入链接地址': 'Please enter a link URL',
  '请选择上级权限': 'Please select the parent permission',
  '请选择分类': 'Please select a category',
  '请选择守卫名称': 'Please select a guard name',
  '请选择所属导航': 'Please select the navigation',
  '请选择是否菜单': 'Please select whether it is a menu',
  '请选择状态': 'Please select a status',
  '请选择请求方法': 'Please select a request method',
  '账单明细_': 'Billing Details_',
  '账号名称': 'Account Name',
  '超级管理员': 'Super Admin',
  '轮播': 'Carousel',
  '近 30 天活跃': 'Active in Last 30 Days',
  '这个地址就是你的企业官网，可直接对外发布，也可绑定你自己的一级域名（联系平台管理员）。': 'This address is your company website. You can publish it directly, or bind your own first-level domain (contact the platform admin).',
  '这里填的联系方式会覆盖企业档案里的默认值，只展示在本官网上。': 'Contact info entered here overrides the defaults in the company profile and is shown only on this website.',
  '连续失败告警阈值（轮）': 'Consecutive Failure Alert Threshold (rounds)',
  '迭代闭环总闸（自改配置，带护栏）': 'Iteration Loop Master Switch (self-tuning config with guardrails)',
  '选择一位数字人助理开始对话，更多助理将陆续接入': 'Pick a digital human assistant to start chatting; more are coming',
  '选择企业后自动生成': 'Auto-generated after selecting a company',
  '通过提现': 'Approve Withdrawal',
  '邮箱': 'Email',
  '邮箱格式不正确': 'Invalid email format',
  '邮箱联系': 'Email',
  '部分图片占位符未还原，请检查译文中的图片是否完整': 'Some image placeholders were not restored; please check that images in the translation are complete',
  '配置列表加载失败，请刷新页面重试': 'Failed to load the config list, please refresh the page',
  '重挖失败：': 'Re-mining failed:',
  '重新上传': 'Re-upload',
  '重新加载': 'Reload',
  '重新自检': 'Re-run Self-check',
  '金额（元）': 'Amount (¥)',
  '金额：': 'Amount:',
  '钱包充值_': 'Wallet Recharge_',
  '链接地址（留空则移除链接）': 'Link URL (leave empty to remove the link)',
  '链接已复制': 'Link copied',
  '陈少华': 'Chen Shaohua',
  '需要标题和内容': 'Title and content are required',
  '页脚': 'Footer',
  '预览可能需要几十秒刷新，如未更新请点刷新': 'The preview may take tens of seconds to refresh; click refresh if it does not update',
  '首页实时预览': 'Homepage Live Preview',
  '首页导航栏预览（实时同步 www.chpen.com）': 'Homepage Nav Bar Preview (live synced with www.chpen.com)',
  '首页导航编辑': 'Homepage Navigation Editing',
  '首页展示中': 'Shown on Homepage',
  '首页有但管理端缺失': 'On homepage but missing in the admin panel',
  '首页横幅（Hero）': 'Homepage Banner (Hero)',
  '验证码已发送': 'Code sent',
  '（未开通）': '(Not enabled)',
  '💾 保存草稿': '💾 Save Draft',
  '📋 复制内容': '📋 Copy Content',
  '📝 草稿箱': '📝 Drafts',
  '🔄 翻译中英': '🔄 Translate ZH-EN',
  '🔄 自动翻译中英': '🔄 Auto Translate ZH-EN',
  '🚀 一键生成': '🚀 Generate',
  '🚀 发布文章': '🚀 Publish Article',
};
